// (max - min) purposely excludes max
export function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

export function getFactors(number){
  var factors = [];
  for (var i = 1; i <= number; i++){
    if (number % i == 0){
        factors.push(i);
    }
  }
  return factors;
}

export function isPrime(number){
  var primes = [1, 2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41,
                43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97];
  if(primes.includes(number)){
    return true;
  }
  else {
    return false;
  }
}

export function getAddSubtractObject(totalNumber, shownFactor){
  var hiddenFactor = totalNumber - shownFactor;
  var solution = hiddenFactor;

  var relatedNumbers = {
    totalNumber: totalNumber,
    shownFactor: shownFactor,
    hiddenFactor: hiddenFactor,
    solution: solution
  };
  return relatedNumbers;
}

export function getMultiplyObject(product, shownFactor){
  var hiddenFactor = product/shownFactor;

  var multiplyRelatedNumbers = {
    totalNumber: product,
    shownFactor: shownFactor,
    hiddenFactor: hiddenFactor,
    solution: hiddenFactor
  };
  return multiplyRelatedNumbers;
}

export function getMultiplyAddObject(result, shownFactor) {
  var hiddenFactor = result - shownFactor;
  if(isPrime(hiddenFactor) === true){
      hiddenFactor++;
      shownFactor--;
    }
  var factorToHide = getShownFactor(hiddenFactor);
  var multiplyRelatedNumbers = {
    totalNumber: result,
    shownFactor: shownFactor,
    hiddenFactor: factorToHide,
    factorToShow: hiddenFactor / factorToHide
  };

  return multiplyRelatedNumbers;
}

export function createSumOrProduct(selected){
  var sumOrProduct;
  if(selected === 'multiplication' || selected === 'addition with multiplication'){
    sumOrProduct = getRandomInt(3, 100);
    if(isPrime(sumOrProduct) === true){
      sumOrProduct++;
    }
  } else {
    sumOrProduct = getRandomInt(2, 26);
  }
  return sumOrProduct;
}

// only needed for multiplication and addition with multiplication
// factors.pop and shift remove 1 and product from factors array to eliminate '1 * y' equations
export function getShownFactor(product){
  var factors = getFactors(product);
  factors.pop();
  factors.shift();
  var shownFactor = factors[Math.floor(Math.random() * factors.length)];
  return shownFactor;
}

export function getRelatedNumbers(selected){
  var shownFactor;
  if (selected === 'multiplication') {
    var product = createSumOrProduct(selected);
    shownFactor = getShownFactor(product);
    return getMultiplyObject(product, shownFactor);
  } else if (selected === 'addition with multiplication') {
    var result = createSumOrProduct(selected);
    shownFactor = getShownFactor(result);
    return getMultiplyAddObject(result, shownFactor);
  }
  else {
    var totalNumber = createSumOrProduct(selected);
    shownFactor = getRandomInt(1, totalNumber);
    var addSubtractNumberSet = getAddSubtractObject(totalNumber, shownFactor);
    return addSubtractNumberSet;
  }
}

export function randomizeOrder(firstTerm, operation, secondTerm) {
  if (Math.random() < 0.5) {
    return `${firstTerm} ${operation} ${secondTerm}`;
  } else {
    return `${secondTerm} ${operation} ${firstTerm}`;
  }
}

// numberObject should be an object to use to create the equation
// selected should be the selected choice from dropdown
export function displayEquation(numberObject, selected) {
  var equationDisplayed;
  if(selected === 'addition'){
    const randomized = randomizeOrder(numberObject.shownFactor, '+', 'y');
    equationDisplayed = `${randomized} = ${numberObject.totalNumber}`;
  }
  if(selected === 'subtraction'){
    equationDisplayed = `${numberObject.totalNumber} - y = ${numberObject.shownFactor}`;
  }
  if(selected === 'multiplication'){
    const randomized = randomizeOrder(numberObject.shownFactor, '*', 'y');
    equationDisplayed = `${randomized} = ${numberObject.totalNumber}`;
  }
  if(selected === 'addition with multiplication'){
    const randomized = randomizeOrder(numberObject.shownFactor, '+',
                                     `${numberObject.factorToShow}y`);
    equationDisplayed = `${randomized} = ${numberObject.totalNumber}`;
  }
  return equationDisplayed;
}

export function checkEquationAnswer(numberObject, equationAnswer){
  if (equationAnswer == numberObject.hiddenFactor) {
    return true;
  } else {
    return false;
  }
}



/** WEBPACK FOOTER **
 ** ./client/app/scripts/components/algebra/lib/basic-algebra.js
 **/